var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterOil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#002455;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(325 -65)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(-325 65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.541-.75h21.2A1.293,1.293,0,0,1,23.033.541V4.385a1.293,1.293,0,0,1-1.291,1.291H.541A1.293,1.293,0,0,1-.75,4.385V.541A1.293,1.293,0,0,1,.541-.75ZM21.533.75H.75V4.176H21.533Z",
    transform: "translate(-318.594 89.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-307.5,69.585a39.565,39.565,0,0,1,9.16,1.17.75.75,0,0,1,.556.725V89.74a.75.75,0,0,1-.75.75h-17.843a.75.75,0,0,1-.75-.75V71.48a.75.75,0,0,1,.552-.723A38.323,38.323,0,0,1-307.5,69.585Zm8.216,2.484a38.807,38.807,0,0,0-8.216-.984,37.669,37.669,0,0,0-8.127.982V88.99h16.343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,15.232H-.008a.75.75,0,0,1-.742-.758L-.594-.008A.75.75,0,0,1,.164-.75.75.75,0,0,1,.906.008L.75,14.49A.75.75,0,0,1,0,15.232Z",
    transform: "translate(-307.574 72.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,14.951H-.008a.75.75,0,0,1-.742-.758l.156-14.2A.75.75,0,0,1,.164-.75.75.75,0,0,1,.906.008L.75,14.209A.75.75,0,0,1,0,14.951Z",
    transform: "translate(-304.564 73.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,14.67H-.008a.75.75,0,0,1-.742-.758L-.594-.008A.75.75,0,0,1,.164-.75.75.75,0,0,1,.906.008L.75,13.928A.75.75,0,0,1,0,14.67Z",
    transform: "translate(-301.555 73.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,14.951H-.008a.75.75,0,0,1-.742-.758l.156-14.2A.75.75,0,0,1,.164-.75.75.75,0,0,1,.906.008L.75,14.209A.75.75,0,0,1,0,14.951Z",
    transform: "translate(-310.584 73.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,14.67H-.008a.75.75,0,0,1-.742-.758L-.594-.008A.75.75,0,0,1,.164-.75.75.75,0,0,1,.906.008L.75,13.928A.75.75,0,0,1,0,14.67Z",
    transform: "translate(-313.596 73.49)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterOil);
export default __webpack_public_path__ + "static/media/icon_filter_oil.e97cd65504f49999936909e8894a7f64.svg";
export { ForwardRef as ReactComponent };